<template>
    <div class="filter-header-box">
        <div class="select-as-button">
            <el-button @click="openSelect"><svg-icon name="tag" />Creator Tag:
                {{ realPicked.length > 0 ? `Selected(${realPicked.length})` : 'All' }}<svg-icon name="arrow" /></el-button>


            <el-select ref="hiddenSelect" default-first-option :reserve-keyword="false"
                @visible-change="handleVisibleChange">
                <el-option v-for="item in creatorList" :key="item.id" :label="item.name" :value="item.id"
                    class="spec-select-dropdown">
                    <template #default>
                        <Checkbox :label_text="item.name" :checked="item.picked"
                            @click.stop.prevent="pickSelect(item)" :use_p="true"/>
                    </template>
                </el-option>
                <div class="select-button-row">
                    <el-button size="small" @click="allClear();">Clear</el-button>
                    <el-button size="small" type="primary" @click="callApi('close')">See results</el-button>
                </div>
            </el-select>


        </div>

        <div class="tag-pick-list">
            <Badage :class="['tag-item-box', styleTagLong(realPicked, v, k)]"
                v-for="(v, k) in realPicked.filter((ee, kk) => { return kk < 2 })" :key="k" :value="v.name"
                :show_tippy="true">
                <svg-icon name="close" @click="clear(v)"/>
            </Badage>
            <Badage v-if="realPicked.length - 2 > 0" :value="`+${realPicked.length - 2}`"></Badage>

        </div>
    </div>
</template>

<script setup>
import Scrollbar from '@/components/ui/Scrollbar.vue';
import emitter from '@/utils/EventBus';
import { ref, onMounted, onUnmounted, computed, getCurrentInstance } from 'vue';
import { ElInput, ElButton, ElDialog, ElSelect, ElOption } from 'element-plus';
import { useStore } from 'vuex';
import Checkbox from '@/components/ui/Checkbox.vue';
import Badage from '@/components/ui/Badage.vue';

const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const store = useStore();
const loading = ref(false);
const hiddenSelect = ref(null);
const realPicked = ref([]);
const creatorList = ref([
    { name: '12', id: 1 ,picked:false},
    { name: '34', id: 2 ,picked:false},
    { name: '366666666666666666666666', id: 3 ,picked:false},
]);

//取得Send to的資料(要傳進Send to)
const getDropApi = async () => {
    //空的再取得,避免多次CALL API
    if (creatorList.value.length === 0 && groupList.value.length === 0) {
        loading.value = true;
        const ajaxs = [
            ajax.get('/announcement/get-creator-list'),
            ajax.get('/announcement/get-group-list'),
        ];

        Promise.all(ajaxs).then((res) => {

            loading.value = false;
        });
    }

};

const styleTagLong = (row, v, k) => {
    if (row.length === 1) {
        return `tag-item-box-only-one`
    } else if (row.length > 1) {
        if (row[0].name.length < 8 && k === 1) {
            return `tag-item-box-pick-long`
        } else if (row[1].name.length < 8 && k === 0) {
            return `tag-item-box-pick-long`
        } else if (row.length === 2) {
            return 'tag-item-box-longer';
        } else {
            return '';
        }
    } else {
        return '';
    }
};

const openSelect = () => {
    const selectRefs = hiddenSelect.value;
    const targetSelect = Array.isArray(selectRefs) ? selectRefs[index] : selectRefs;
    if (targetSelect) {
        creatorList.value.forEach(creator => {
            creator.picked = realPicked.value.some(picked => picked.id === creator.id);
        });
        targetSelect.toggleMenu(); // 正確開啟下拉
    }
};
const handleVisibleChange = (isVisible) => {
    if (!isVisible) {
    }
};

const pickSelect = (item) => {
    creatorList.value.forEach(creator => {
        if (creator.id === item.id) {
            creator.picked = !creator.picked; // 切換選擇狀態
        }
    });
};

const clear = (v) => {
    realPicked.value = realPicked.value.filter(item => item.id !== v.id);
};

const allClear= () => {
    creatorList.value.forEach(creator => {
        creator.picked = false; // 清除所有選擇狀態
    });
}

const callApi = (type) => {
    
    if(type=='close'){
        realPicked.value = creatorList.value.filter(item => item.picked);
        const selectRefs = hiddenSelect.value;
        const targetSelect = Array.isArray(selectRefs) ? selectRefs[index] : selectRefs;
        if (targetSelect) {
            targetSelect.toggleMenu(false);
        };
    }

    //call
    // if (picked.value.length > 0) {
    //     emitter.emit('content-tag-filter', picked.value);
    // } else {
    //     emitter.emit('content-tag-filter', []);
    // }
};
//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
onMounted(() => {

});

onUnmounted(() => {

});

</script>

<style lang="scss">
.filter-header-box {
    flex: 1;
    display: flex;
    align-items: center;

    .select-as-button {
        position: relative;
        margin-right: 8px;


        .el-select {
            position: absolute;
            left: 0;
            z-index: -1;
            top: 0;
            width: 150px;
        }

        .el-button {
            padding: 0 8px;

            span {
                gap: 4px;
            }
        }

        svg {
            width: 10px;
            height: 10px;
            margin-left: 8px;
            margin-top: 2px;
        }

        .svg-icon--tag {
            width: 16px;
            height: 16px;
            margin: 0;
            margin-top: 2px;
        }

    }


    .tag-pick-list {
        display: flex;
        align-items: center;
        padding: 4px;
        gap: 6px;
        border: solid 1px var(--white);
        flex:1;

        .my-badges-iden {
            display: flex;
            align-items: center;
            border-radius: 6px;
            font:var(--font-med-14);
            height: 32px;
            border: solid 1px var(--border);
            padding: 6px 8px;

            span {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 86px;
            }

            &.tag-item-box-only-one span {
                max-width: 250px;
            }

            &.tag-item-box-longer span {
                max-width: 100px;
            }

            &.tag-item-box-pick-long span {
                max-width: 150px;
            }

            &:first-child {
                span {
                    max-width: 150px;
                }
            }
        }


        .svg-icon {
            margin-left: 6px;
            width: 8px;
            cursor: pointer;
        }

        &.edit-tags-list-box {
            border: solid 1px var(--neutral);
            border-radius: 6px;

        }

    }
}

.select-button-row {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 0 8px;
    margin-top: 8px;
}

.spec-select-dropdown {
    padding-right: 0;

    p{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 90px;
    }

    .ui-checkbox {
        margin: 0;
        width: 100%;
    }
}
</style>
